import React from 'react'
import ReactDOM from 'react-dom/client'
import TagManager from 'react-gtm-module'

import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'

const gtmId = process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID
if (gtmId) {
  TagManager.initialize({ gtmId })
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
